export const getCurrencySymbol = (currency: string) => {
  return (
    {
      GBP: '£',
      USD: '$',
      EUR: '€',
    }[currency.toUpperCase()] || '£'
  );
};

export const getCurrencyChangeLetter = (currency: string) => {
  return (
    {
      GBP: 'p',
      USD: 'c',
      EUR: 'c',
    }[currency.toUpperCase()] || 'p'
  );
};
